class QuestionBeforeInvesting {
    constructor({ question }) {
        this._question = question;
    }

    get question() { return this._question; }
}

export default QuestionBeforeInvesting;